function isFractionalPartOne(num: number) {
    const parts = num.toString().split('.');
    return parts.length > 1 && parts[1] === '1';
}

export function switchCostLabel(
    cost: number,
    labels: [string, string],
): string {
    if (isFractionalPartOne(cost)) {
        return labels[0];
    } else {
        return labels[1];
    }
}
